import React from 'react';

import ControlledNumericInput from 'ui-library/inputs/ControlledNumericInput';
import {ElementKeyboardEvent, NumericInputChangeEvent} from 'util/Types';

export interface ControlledNumericValueEditorProps {
  defaultValue?: {value?: string | number | null} | null;
  useStringValue?: boolean;
  autoFocus: boolean;
  onChange: (tag: object) => void;
  placeholder?: string;
  value?: string | number | null;
  valueAccessorKey: string;
  onKeyDown?: (e: ElementKeyboardEvent) => void;
}

export default function ControlledNumericValueEditor(props: ControlledNumericValueEditorProps): JSX.Element {
  const value = props.defaultValue ? props.defaultValue.value : null;

  const handleChange = (e: NumericInputChangeEvent): void => {
    const proposedValue =
      props.useStringValue || e.target.numericValue == null ? e.target.value : e.target.numericValue;
    props.onChange({
      [props.valueAccessorKey]: proposedValue === '' ? null : proposedValue,
      value: e.target.value,
    });
  };
  return (
    <ControlledNumericInput
      focusOnMount={props.autoFocus}
      onKeyDown={props.onKeyDown}
      onChange={handleChange}
      placeholder={props.placeholder}
      value={value}
    />
  );
}
